<div class="ts1-select-maneuver-modal flex h-full flex-col overflow-hidden">
	<div class="dialog-header">
		<div class="text-base font-bold text-black">Select Maneuver</div>
		<div class="text-sm text-grey-40">Choose a maneuver to add to this form</div>
	</div>

	<div class="dialog-content">
		@if (availableOptions.length === 0) {
			<div class="text-sm italic text-grey-40">All maneuvers have already been added.</div>
		} @else {
			<div class="form-element">
				<mat-label for="ts1-maneuver-select">Maneuver</mat-label>
				<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
					<input
						id="ts1-maneuver-select"
						type="text"
						matInput
						[formControl]="maneuverControl"
						placeholder="Select Maneuver"
						[matAutocomplete]="maneuverAuto"
					/>
					@if (selected) {
						<button
							matSuffix
							mat-icon-button
							type="button"
							aria-label="Clear"
							(click)="clearSelection()"
							class="!size-[unset] !p-2"
						>
							<span class="aa-mat-icon">close</span>
						</button>
					}
					<span matSuffix class="aa-mat-icon mr-4">keyboard_arrow_down</span>
					<mat-autocomplete
						#maneuverAuto="matAutocomplete"
						[displayWith]="displayFn"
						(optionSelected)="onOptionSelected($event)"
					>
						@for (option of filteredOptions | async; track option.code) {
							<mat-option [value]="option">{{ option.description }}</mat-option>
						}
					</mat-autocomplete>
				</mat-form-field>
			</div>
		}
	</div>

	<div class="dialog-footer">
		<button type="button" class="aa-btn min-w-24" data-variant="tertiary" data-size="small" (click)="cancel()">
			Cancel
		</button>
		<div class="flex-1"></div>
		<button
			type="button"
			class="aa-btn min-w-24"
			data-variant="primary"
			data-size="small"
			[disabled]="!selected"
			(click)="continue()"
		>
			Continue
		</button>
	</div>
</div>
